<app-loader [loading]="initializingView" [overlay]="true"></app-loader>
<div *ngIf="booking && !contentHidden">
  <a class="link bottom-spacer" (click)="toList()" *ngIf="!hasParentBooking">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
    <span>{{'general.api_reservation_exit' | translate}}</span>
  </a>
  <a class="link bottom-spacer" (click)="toInitial()" *ngIf="hasParentBooking">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
    <span>{{'general.api_reservation_back_to_initial' | translate}}</span>
  </a>
  <div class="content-with-sidebar" [ngClass]="{'overlay': modalIsOpened, 'with-footer': !isCancelled}">
    <div class="content">
      <div class="flex space-between">
        <div class="heading-2">
          {{'general.api_reservation_list_number' | translate}}: {{ booking.number }}
          <span class="badge right-spacer" [class]="booking.status">{{('general.api_reservation_status_' + booking.status) | translate}}</span>
          <span class="badge">{{('general.api_reservation_type_' + booking.type) | translate}}</span>
        </div>
        <div class="desktop flex flex-center bottom-spacer">
          <ng-container [ngTemplateOutlet]="bookingChangeButton"></ng-container>
        </div>
      </div>
      <mat-tab-group class="mobile" mat-align-tabs="left" animationDuration="0ms"
                     [selectedIndex]="activeTab" (selectedIndexChange)="activeTab = $event">
        <mat-tab [label]="'general.api_reservation_info' | translate">
          <ng-container [ngTemplateOutlet]="bookingInfo"></ng-container>
        </mat-tab>
        <mat-tab [label]="'general.api_reservation_tickets' | translate" *ngIf="booking?.bookingCart?.events?.length">
          <ng-container [ngTemplateOutlet]="bookingTickets"></ng-container>
        </mat-tab>
        <mat-tab [label]="'general.api_reservation_details' | translate">
          <ng-container [ngTemplateOutlet]="bookingDetails"></ng-container>
        </mat-tab>
      </mat-tab-group>
      <!-- INFO -->
      <ng-container *ngIf="!utilService.isMobile">
        <ng-container [ngTemplateOutlet]="bookingInfo"></ng-container>
      </ng-container>
      <div *ngIf="booking?.bookingCart?.events?.length" class="desktop">
        <ng-container [ngTemplateOutlet]="bookingTickets"></ng-container>
      </div>
    </div>
    <div class="desktop sidebar">
      <ng-container [ngTemplateOutlet]="bookingDetails"></ng-container>
    </div>
  </div>
</div>
<ng-container *ngIf="modalIsOpened">
  <div class="mobile flex flex-column with-footer">
    <ng-container [ngTemplateOutlet]="bookingProcessModal"></ng-container>
    <app-cart-totals [cartService]="bookingsService"></app-cart-totals>
  </div>
</ng-container>
<footer class="mobile" *ngIf="!isCancelled">
  <mat-dialog-actions class="flex flex-column">
    <ng-container *ngIf="!modalIsOpened">
      <ng-container *ngIf="isActive" [ngTemplateOutlet]="activeBookingButtons"></ng-container>
      <button mat-flat-button color="primary" *ngIf="isReleased" (click)="openTransaction()">
        {{ 'general.api_reservation_open_transaction' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="modalIsOpened && modalType === 'issue'">
      <ng-container [ngTemplateOutlet]="bookingProcessIssueButtons"></ng-container>
    </ng-container>
    <ng-container *ngIf="modalIsOpened && modalType === 'sendEmail'">
      <ng-container [ngTemplateOutlet]="bookingProcessSendEmailButtons"></ng-container>
    </ng-container>
    <ng-container *ngIf="modalIsOpened && modalType === 'confirmPrint'">
      <ng-container [ngTemplateOutlet]="bookingProcessConfirmPrintButtons"></ng-container>
    </ng-container>
    <ng-container *ngIf="modalIsOpened && modalType === 'waybill'">
      <ng-container [ngTemplateOutlet]="bookingProcessWaybillButtons"></ng-container>
    </ng-container>
  </mat-dialog-actions>
</footer>
<!-- BOOKING DETAILS -->
<ng-template #bookingDetails>
  <ng-container *ngIf="!modalIsOpened">
    <div class="heading-3 bold">{{ 'general.api_reservation_details' | translate }}</div>
    <div class="flex flex-column">
      <div>
        <app-label-value [singleLine]="true" [link]="true" (linkAction)="booking.invoiceUuid ? invoiceService.downloadInvoiceByUuid(booking.invoiceUuid) : downloadInvoice(booking)"
                         [label]="isReleased ? 'general.api_booking_invoice_nr' : 'general.api_booking_order_confirmation_nr'" [value]="booking.invoiceNumber"></app-label-value>
        <app-label-value *ngIf="booking.type === bookingType.Organiser && booking.promoter" [singleLine]="true"
                         [label]="'general.api_booking_promoter'" [value]="booking.promoter.title"></app-label-value>
      </div>
      <a *ngIf="booking.invoiceUuid" class="link" (click)="openInvoiceEmailModal()">
        <mat-icon class="svg-icon" [svgIcon]="'e_mail'"></mat-icon>
        <span>{{(isReleased ? 'general.api_booking_email_invoice' : 'general.api_booking_email_order_confirmation') | translate}}</span>
      </a>
      <div class="flex" *ngIf="centrePropertyService.isEnabled('can_waybill')">
        <a class="link" *ngIf="!booking.hasWaybill" (click)="createWaybill()">
          <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
          <span>{{ 'general.api_reservation_waybill_create' | translate }}</span>
        </a>
        <a class="link" *ngIf="booking.hasWaybill" (click)="openWaybill()">
          <mat-icon class="svg-icon" [svgIcon]="'file_pdf'"></mat-icon>
          <span>{{ 'general.api_reservation_waybill_open' | translate }}</span>
        </a>
        <a class="link" *ngIf="booking.hasWaybill" (click)="changeWaybill()">
          <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
          <span>{{ 'general.api_reservation_waybill_change' | translate }}</span>
        </a>
      </div>
    </div>
    <hr class="slim">
    <ng-container *ngIf="(isActive || isReleased) && booking.paymentType === 'transfer' && authService.checkPrivileges(Privileges.BOOKING_MARK_PAYMENT_RECEIVED)">
      <div class="flex flex-column">
        <app-label-value *ngIf="booking.receivedPayment" [singleLine]="true"
                         [label]="'general.api_reservation_payment_received_on'" [value]="booking.receivedPayment | moment"></app-label-value>
        <ng-container *ngIf="!booking.receivedPayment">
          <app-datepicker [(date)]="paidDate" [datePickerConfig]="paidDateConfig"></app-datepicker>
          <button mat-stroked-button color="primary" (click)="markAsPaid()">
            {{ 'general.api_reservation_mark_as_paid' | translate }}
          </button>
        </ng-container>
        <button mat-stroked-button color="primary" *ngIf="booking.receivedPayment && authService.checkPrivileges(Privileges.BOOKING_PAYMENT_CANCEL)"
                (click)="markAsUnpaid()">
          {{ 'general.api_reservation_mark_as_unpaid' | translate }}
        </button>
      </div>
      <hr class="slim">
    </ng-container>
    <ng-container *ngIf="isActive">
      <div class="flex flex-column bottom-spacer">
        <app-text-input [type]="TextInputType.Email" [label]="'general.api_cart_client_notification_email'" [(value)]="clientNotificationEmail"></app-text-input>
        <app-promocode [service]="bookingsService"></app-promocode>
        <app-gift-code *ngIf="authService.checkPrivileges(Privileges.GIFT_TICKET_USAGE)" [service]="bookingsService"></app-gift-code>
        <app-numeric-input *ngIf="authService.checkPrivileges(Privileges.DISCOUNT_APPLY) || booking.bookingCart.discountPercent"
                           [type]="NumericInputType.Percentage" [withLinkButton]="authService.checkPrivileges(Privileges.DISCOUNT_APPLY)"
                           (linkButtonClicked)="bookingsService.applyDiscount(discount)"
                           [label]="'general.api_cart_discount'" [(value)]="discount"
                           (inputKeyup)="utilService.isEnterKey($event) ? bookingsService.applyDiscount(discount) : null"
                           [disabled]="bulkMode || !authService.checkPrivileges(Privileges.DISCOUNT_APPLY)"></app-numeric-input>
        <ng-container *ngIf="canViewPaymentOptions">
          <mat-form-field #paymentTypeField appearance="outline" [ngClass]="(!booking.paymentType && highlightPaymentTypeError) ? 'field-error' : 'no-hint'">
            <mat-label>{{'general.api_reservation_list_payment_type' | translate}}</mat-label>
            <mat-select [(ngModel)]="booking.paymentType" [ngModelOptions]="{standalone: true}"
                        (selectionChange)="bookingChanged = true; saveBookingChanges()" [disabled]="!canEdit">
              <mat-select-trigger>{{('general.api_cart_' + booking.paymentType) | translate}}</mat-select-trigger>
              <mat-option [value]="null">-</mat-option>
              <mat-option *ngFor="let paymentType of paymentTypes" [value]="paymentType">
                {{ ('general.api_cart_' + paymentType) | translate }}
              </mat-option>
            </mat-select>
            <mat-hint class="text-warning" *ngIf="!booking.paymentType && highlightPaymentTypeError">
              <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
              {{'general.api_reservation_payment_type_required_for_issue' | translate}}
            </mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="no-hint">
            <mat-label>{{'general.api_reservation_list_delivery_type' | translate}}</mat-label>
            <mat-select [(ngModel)]="booking.deliveryTypeId" [ngModelOptions]="{standalone: true}"
                        (selectionChange)="bookingChanged = true; saveBookingChanges()" [disabled]="!canEdit">
              <mat-select-trigger>{{ deliveryType?.name | translate }}</mat-select-trigger>
              <mat-option [value]="null" *ngIf="booking.type === bookingType.Organiser">-</mat-option>
              <mat-option *ngFor="let deliveryType of booking.deliveryTypes" [value]="deliveryType.id">
                {{ deliveryType.name | translate}} - {{deliveryType.price | price}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
  <!-- ISSUE MODAL -->
  <div class="following-modal desktop" *ngIf="modalIsOpened">
    <ng-container [ngTemplateOutlet]="bookingProcessModal"></ng-container>
  </div>
  <app-cart-totals [cartService]="bookingsService"></app-cart-totals>
  <div class="flex flex-column desktop" *ngIf="!modalIsOpened">
    <ng-container *ngIf="isActive">
      <ng-container [ngTemplateOutlet]="activeBookingButtons"></ng-container>
    </ng-container>
    <button mat-flat-button color="primary" *ngIf="isReleased" (click)="openTransaction()">
      {{ 'general.api_reservation_open_transaction' | translate }}
    </button>
  </div>
</ng-template>
<!-- PROCESS MODAL -->
<ng-template #bookingProcessModal>
  <div class="flex flex-center space-between bottom-spacer">
    <div class="heading-3 no-margin bold break-word">
      <ng-container *ngIf="modalType === 'issue'">
        {{ 'general.api_cart_issue_tickets_title' | translate }}
      </ng-container>
      <ng-container *ngIf="modalType === 'sendEmail'">
        {{ 'general.api_cart_send_email_title' | translate }}
      </ng-container>
      <ng-container *ngIf="modalType === 'confirmPrint'">
        {{ 'general.api_printing' | translate }}
      </ng-container>
      <ng-container *ngIf="modalType === 'waybill'">
        {{ (isWaybillEdit ? 'general.api_reservation_waybill_edit_title' : 'general.api_reservation_waybill_create_title') | translate }}
      </ng-container>
    </div>
    <div class="mobile align-right" *ngIf="modalType !== 'confirmPrint'">
      <button mat-button class="icon-button" (click)="closeModal()">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>
  <mat-card appearance="outlined" *ngIf="modalType !== 'confirmPrint' || !utilService.isMobile">
    <mat-card-content>
      <div class="flex flex-column" *ngIf="modalType === 'issue'">
        <app-label-value *ngIf="canChooseTicketFormat" [label]="'general.api_cart_ticket_format'"
                         [template]="ticketFormatTemplate" [withMargin]="true"></app-label-value>
        <ng-template #ticketFormatTemplate>
          <mat-radio-group class="flex flex-column" [(ngModel)]="ticketType">
            <mat-radio-button [value]="printTicketType.Plp">{{ 'general.api_cart_format_basic' | translate }}</mat-radio-button>
            <mat-radio-button [value]="printTicketType.Pdf">{{ 'general.api_cart_format_pdf' | translate }}</mat-radio-button>
          </mat-radio-group>
        </ng-template>
        <app-label-value *ngIf="canChoosePrintCount" [label]="'general.api_cart_tickets_printed_count_by'"
                         [template]="ticketCountTemplate" [withMargin]="true"></app-label-value>
        <ng-template #ticketCountTemplate>
          <mat-form-field appearance="outline" class="no-hint">
            <mat-select [(ngModel)]="ticketsPrintedCountBy" [ngModelOptions]="{standalone: true}"
                        [placeholder]="'general.api_cart_tickets_printed_count_by' | translate">
              <mat-select-trigger>{{('general.api_cart_tickets_printed_count_by_' + ticketsPrintedCountBy) | translate}}</mat-select-trigger>
              <mat-option [value]="'all'">{{ 'general.api_cart_tickets_printed_count_by_all' | translate }}</mat-option>
              <mat-option [value]="1">{{ 'general.api_cart_tickets_printed_count_by_1' | translate }}</mat-option>
              <mat-option [value]="2" *ngIf="bookingsService.ticketCount > 2">{{ 'general.api_cart_tickets_printed_count_by_2' | translate }}</mat-option>
              <mat-option [value]="3" *ngIf="bookingsService.ticketCount > 3">{{ 'general.api_cart_tickets_printed_count_by_3' | translate }}</mat-option>
              <mat-option [value]="4" *ngIf="bookingsService.ticketCount > 4">{{ 'general.api_cart_tickets_printed_count_by_4' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
        <app-label-value *ngIf="bookingsService.canPrintWithoutPrice" [label]="'general.api_cart_print_tickets'"
                         [template]="printWithoutPriceTemplate" [withMargin]="true"></app-label-value>
        <ng-template #printWithoutPriceTemplate>
          <mat-radio-group class="flex flex-column" [(ngModel)]="priceInfo">
            <mat-radio-button [value]="priceInfoEnum.Regular">{{ 'general.api_cart_print_tickets_regular' | translate }}</mat-radio-button>
            <mat-radio-button [value]="priceInfoEnum.Invitation">{{ 'general.api_cart_print_tickets_invitation' | translate }}</mat-radio-button>
            <mat-radio-button [value]="priceInfoEnum.None">{{ 'general.api_cart_print_tickets_without_price' | translate }}</mat-radio-button>
          </mat-radio-group>
        </ng-template>
        <div class="flex flex-column desktop">
          <ng-template [ngTemplateOutlet]="bookingProcessIssueButtons"></ng-template>
        </div>
      </div>
      <div class="flex flex-column" *ngIf="modalType === 'sendEmail'">
        <app-info-message *ngIf="zippedTicketsSent" [message]="'general.api_cart_zipped_tickets_sent_in_email'"></app-info-message>
        <app-text-input [type]="TextInputType.Email"
                        [label]="'general.api_cart_client_email'" [(value)]="clientEmail"></app-text-input>
        <div class="flex flex-column desktop">
          <ng-container [ngTemplateOutlet]="bookingProcessSendEmailButtons"></ng-container>
        </div>
      </div>
      <div class="flex flex-column" *ngIf="modalType === 'confirmPrint'">
        <ng-container [ngTemplateOutlet]="bookingProcessConfirmPrintButtons"></ng-container>
      </div>
      <div class="flex flex-column" *ngIf="modalType === 'waybill'">
        <!-- Customer -->
        <app-scroll-load [minInput]="2" [maxWidth]="true" [label]="'general.api_reservation_table_customer' | translate"
                         [customFilters]="{legalPersonId: booking.legalPersonId}" [searchService]="customerService" [scrollLoad]="bookingCustomerScrollLoad"
                         [(selectedObjectId)]="waybillCustomer" (selectedObjectIdChange)="selectBookingCustomer()"></app-scroll-load>
        <app-text-input [label]="'general.api_reservation_waybill_shipment_basis'" [(value)]="waybill.shipmentBasis"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_licensor'" [(value)]="waybill.licensor"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_supplier'" [(value)]="waybill.supplier"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_deliverer'" [(value)]="waybill.deliverer"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_mandate'" [(value)]="waybill.mandate"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_authority'" [(value)]="waybill.authority"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_recipient'" [(value)]="waybill.recipient"></app-text-input>
        <app-text-input [label]="'general.api_reservation_waybill_attachments'" [(value)]="waybill.attachments"></app-text-input>
        <div class="flex flex-column desktop">
          <ng-container [ngTemplateOutlet]="bookingProcessWaybillButtons"></ng-container>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<ng-template #bookingProcessIssueButtons>
  <button mat-flat-button color="primary" [disabled]="!isValidClientNotificationEmail || disabledButtons" (click)="releaseBooking()">
    {{ 'general.api_reservation_release' | translate }}
  </button>
  <button mat-stroked-button color="primary" *ngIf="ticketType === printTicketType.Pdf"
          [disabled]="!isValidClientNotificationEmail || disabledButtons" (click)="openEmailModal()">
    {{ 'general.api_printing_send_to_email' | translate }}
  </button>
  <button mat-button (click)="closeModal()" [disabled]="disabledButtons">
    {{ 'general.api_cart_release_cancel' | translate }}
  </button>
</ng-template>
<ng-template #bookingProcessSendEmailButtons>
  <button mat-flat-button color="primary"
          (click)="proceedTransaction()"
          [disabled]="!isValidEmail(clientEmail) || disabledButtons">
    {{ 'general.api_cart_release_continue' | translate }}
  </button>
  <button mat-button (click)="closeModal()" [disabled]="disabledButtons">
    {{ 'general.api_cart_release_cancel' | translate }}
  </button>
</ng-template>
<ng-template #bookingProcessConfirmPrintButtons>
  <button mat-flat-button color="primary" (click)="confirmPrinting()">
    {{ 'general.api_printing_confirm' | translate }}
  </button>
  <button mat-stroked-button color="primary" (click)="scrappingProcess()">
    {{ 'general.api_printing_fail' | translate }}
  </button>
</ng-template>
<ng-template #bookingProcessWaybillButtons>
  <button mat-flat-button color="primary" (click)="proceedWaybill()" [disabled]="!isValidWaybill">
    {{ (isWaybillEdit ? 'general.api_reservation_waybill_change' : 'general.api_reservation_waybill_proceed') | translate }}
  </button>
  <button mat-button (click)="cancelWaybill()">
    {{ 'general.api_reservation_waybill_cancel' | translate }}
  </button>
</ng-template>
<!-- BOOKING INFO -->
<ng-template #bookingInfo>
  <div class="mobile flex flex-end bottom-spacer">
    <ng-container [ngTemplateOutlet]="bookingChangeButton"></ng-container>
  </div>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="flex flex-grow flex-column-mobile">
        <ng-container *ngIf="booking.type !== bookingType.Organiser">
          <!-- Legal person -->
          <div class="flex flex-flat" *ngIf="authService.hasLegalGetPrivilege">
            <app-scroll-load label="general.api_reservation_table_legal_person" [minInput]="3"
                             [maxWidth]="true" [withSuffix]="canEdit && isActive"
                             [displayOption]="legalPersonDisplay"
                             [customQuery]="legalPersonService.setPageableQuery"
                             [searchService]="legalPersonService" [scrollLoad]="bookingLegalPersonScrollLoad"
                             [disabled]="!canEdit || !isActive" [required]="booking.type === bookingType.Client && !!booking.legalPersonId"
                             [(selectedObjectId)]="booking.legalPersonId" (selectedObjectIdChange)="selectBookingLegalPerson()"
                             (clearEvent)="showLegalPersonForm = false"></app-scroll-load>
            <button mat-button class="icon-button input-button suffix-button" [matMenuTriggerFor]="legalPersonMenu" *ngIf="canEdit && isActive">
              <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
            </button>
            <mat-menu #legalPersonMenu="matMenu">
              <button mat-menu-item (click)="displayLegalPersonForm(true)" [disabled]="booking.status === BookingStatus.Cancelled">
                <mat-icon class="svg-icon" [svgIcon]="'add_legal_person'"></mat-icon>
                <span>{{'general.api_legal_persons_form_create_title' | translate}}</span>
              </button>
              <button mat-menu-item (click)="displayLegalPersonForm()" [disabled]="booking.status === BookingStatus.Cancelled || !booking.legalPersonId">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                <span>{{'general.api_legal_persons_form_edit_title' | translate}}</span>
              </button>
            </mat-menu>
          </div>
          <!-- Customer -->
          <div class="flex flex-flat">
            <app-scroll-load label="general.api_reservation_table_customer" [minInput]="booking.legalPersonId ? 0 : 2"
                             [maxWidth]="true" [withSuffix]="canEdit && isActive"
                             [customFilters]="{legalPersonId:booking.legalPersonId}"
                             [searchService]="customerService" [scrollLoad]="bookingCustomerScrollLoad"
                             [disabled]="!canEdit || !isActive" [required]="booking.type === bookingType.Client"
                             [(selectedObjectId)]="booking?.customer.uuid" (selectedObjectIdChange)="selectBookingCustomer()"
                             (clearEvent)="showCustomerForm = false"></app-scroll-load>
            <button mat-button class="icon-button input-button suffix-button" [matMenuTriggerFor]="customerMenu" *ngIf="canEdit && isActive">
              <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
            </button>
            <mat-menu #customerMenu="matMenu">
              <button mat-menu-item (click)="displayCustomerForm(true)" [disabled]="booking.status === BookingStatus.Cancelled">
                <mat-icon class="svg-icon" [svgIcon]="'add_user'"></mat-icon>
                <span>{{'general.api_customers_form_create_title' | translate}}</span>
              </button>
              <button mat-menu-item (click)="displayCustomerForm()" [disabled]="booking.status === BookingStatus.Cancelled || !booking.customer?.uuid">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                <span>{{'general.api_customers_form_edit_title' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </ng-container>
        <app-datepicker class="bottom-spacer" [dateStart]="bookingDate" [(dateEnd)]="dueDate"
                        [datePickerConfig]="bookingPeriodConfig" [disabled]="!canEdit || !isActive"
                        (dateEndChange)="checkDueDateChange()"></app-datepicker>
      </div>
      <div class="card-inner-component bottom-spacer" *ngIf="showLegalPersonForm">
        <app-legal-person-view [legalPersonId]="booking.legalPersonId" [withoutFooter]="true"
                               (cancelChange)="cancelLegalPersonChange()" (confirmChange)="selectLegalPerson($event)"
                               [readonly]="!canEdit || !isActive" [isInternalComponent]="true"></app-legal-person-view>
        <hr class="mobile slim">
      </div>
      <div class="card-inner-component bottom-spacer" *ngIf="showCustomerForm">
        <app-customer-view [customerUuid]="booking.customer?.uuid" [withoutFooter]="true"
                           (cancelChange)="cancelCustomerChange()" (confirmChange)="selectCustomer($event)"
                           [readonly]="!canEdit || !isActive" [legalPerson]="selectedLegalPerson" [isInternalComponent]="true"></app-customer-view>
        <hr class="mobile slim">
      </div>
      <div class="flex flex-grow flex-column-mobile">
        <app-text-input class="max-width" [type]="TextInputType.Textarea"
                        [label]="'general.api_reservation_list_notes'" [(value)]="booking.notes" (valueChange)="bookingChanged = true"
                        [max]="1000" [disabled]="!authService.checkPrivileges(Privileges.BOOKING_CHANGE)"></app-text-input>
        <app-text-input class="max-width" *ngIf="booking.type !== bookingType.Organiser" [type]="TextInputType.Textarea" (valueChange)="internalCommentChanged = true"
                        [label]="'general.api_reservation_internal_comment'" [(value)]="booking.internalComment"
                        [disabled]="!canEdit || !isActive || !authService.checkPrivileges(Privileges.BOOKING_CHANGE)"></app-text-input>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<!-- BOOKING TICKETS -->
<ng-template #bookingTickets>
  <div class="flex bottom-spacer space-between" *ngIf="isActive">
    <mat-form-field appearance="outline" class="no-hint no-label">
      <mat-select [(ngModel)]="bookingsService.groupTicketsBy" [ngModelOptions]="{standalone: true}">
        <ng-container *ngFor="let groupBy of groupTicketsValues">
          <mat-option *ngIf="!bulkMode || groupBy !== groupTickets.None" [value]="groupBy">
            {{'general.api_cart_group_tickets_by_' + groupBy | translate}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <div class="flex flex-flat" [ngClass]="{'flex-center': !utilService.isMobile}">
      <div class="desktop flex">
        <a class="link" *ngIf="canPartiallyCancel && !bulkMode" (click)="cancelBookingPartial()">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          <span>{{ 'general.api_reservation_partial_cancel' | translate }}</span>
        </a>
        <a class="link" (click)="navigateToEventSearchView()">
          <mat-icon class="svg-icon" [svgIcon]="'booking_add'"></mat-icon>
          <span>{{ 'general.api_reservation_add_new_tickets' | translate }}</span>
        </a>
        <a class="link" *ngIf="canSplit && !bulkMode" (click)="splitBooking()">
          <mat-icon class="svg-icon" [svgIcon]="'split'"></mat-icon>
          <span>{{ 'general.api_reservation_split' | translate }}</span>
        </a>
        <a class="link" *ngIf="canBulkChange" (click)="toggleBulkMode()">
          <mat-icon class="svg-icon" [svgIcon]="bulkMode ? 'save' : 'bulk_change'"></mat-icon>
          <span>{{ (bulkMode ? 'general.api_cart_bulk_mode_done' : 'general.api_cart_bulk_mode_enter') | translate }}</span>
        </a>
      </div>
      <div class="mobile flex decreased-margin">
        <button mat-button class="input-button icon-button" *ngIf="canBulkChange" (click)="toggleBulkMode()">
          <mat-icon class="svg-icon" [svgIcon]="bulkMode ? 'save' : 'bulk_change'"></mat-icon>
        </button>
        <button mat-button class="input-button icon-button" [matMenuTriggerFor]="cartActions">
          <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
        </button>
        <mat-menu #cartActions="matMenu" [xPosition]="'before'">
          <button mat-menu-item *ngIf="canPartiallyCancel && !bulkMode" (click)="cancelBookingPartial()">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            <span>{{ 'general.api_reservation_partial_cancel' | translate }}</span>
          </button>
          <button mat-menu-item (click)="navigateToEventSearchView()">
            <mat-icon class="svg-icon" [svgIcon]="'booking_add'"></mat-icon>
            <span>{{ 'general.api_reservation_add_new_tickets' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="canSplit && !bulkMode" (click)="splitBooking()">
            <mat-icon class="svg-icon" [svgIcon]="'split'"></mat-icon>
            <span>{{ 'general.api_reservation_split' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <mat-card appearance="outlined" class="with-overflow" *ngIf="!utilService.isMobile">
    <mat-card-content class="tickets">
      <ng-container *ngTemplateOutlet="cartTable"></ng-container>
    </mat-card-content>
  </mat-card>
  <ng-container *ngIf="utilService.isMobile">
    <ng-container *ngTemplateOutlet="cartTable"></ng-container>
  </ng-container>
</ng-template>
<ng-template #cartTable>
  <app-cart-table [service]="bookingsService"
                  [isLoading]="isLoading" [bulkMode]="bulkMode" [activeBookingMode]="isActive"
                  [canEdit]="canEdit" [canSelect]="canSelect"
                  (navigateToEventView)="navigateToEventView($event)" (toggleBulkMode)="toggleBulkMode()"
  ></app-cart-table>
</ng-template>
<!-- BOOKING INFO CHANGE BUTTON -->
<ng-template #bookingChangeButton>
  <a class="link" *ngIf="authService.checkPrivileges(Privileges.BOOKING_CHANGE)"
     (click)="!isChangeDisabled && saveBookingChanges()" [attr.aria-disabled]="isChangeDisabled">
    <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
    <span>{{ 'general.api_reservation_change' | translate }}</span>
  </a>
</ng-template>
<ng-template #activeBookingButtons>
  <div class="flex flex-column mobile-max-width">
    <button mat-flat-button color="primary" *ngIf="isReleaseAllowed && !bookingsService.cartDraftEvent?.isDraft"
            [disabled]="!isValidClientNotificationEmail || isLoading" (click)="openIssueModal()">
      {{ 'general.api_reservation_issue' | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="authService.checkPrivileges(Privileges.BOOKING_CHANGE)"
            [disabled]="!bookingsService.areAllTicketsSelected" (click)="cancel()">
      {{ 'general.api_reservation_cancel' | translate }}
    </button>
  </div>
</ng-template>
